import React from "react";
import "../css/MainScreen.css";
import {
    IconButton,
    AppBar,
    makeStyles,
    Grid,
    Badge,
} from "@material-ui/core";
import PlayIcon from "./svg/PlayIcon";
import SelectedPlayIcon from "./svg/SelectedPlayIcon";
import StatsIcon from "./svg/StatsIcon";
import SelectedStatsIcon from "./svg/SelectedStatsIcon";
import ProfileIcon from "./svg/ProfileIcon";
import SelectedProfileIcon from "./svg/SelectedProfileIcon";
import SettingsIcon from "./svg/SettingsIcon";
import SelectedSettingsIcon from "./svg/SelectedSettingsIcon";

import routes from "../../utils/routes.json";
import { Link } from "react-router-dom";
import { UserContext } from "../../viewmodel/providers/user-context";
import { LowerbarState } from "../../model/lowerBarState";

const useStyles = makeStyles({
    groupedTextHorizontal: {
        width: "40%",
        display: "flex",
        minWidth: "320px",
    },
    IconButtonRoot: {
        borderRadius: 0,
    },
    link: {
        margin: "0 auto",
    },
    badge: {
        backgroundColor: "#959EA7",
        borderRadius: "50%",
        color: "#959EA7",
    },
});

type LowerBarProps = {
    lowerBarState?: LowerbarState;
}

export default function LowerBar({ lowerBarState }: LowerBarProps): JSX.Element {
    const classes = useStyles();

    const notifications = React.useContext(UserContext).notifications;
    const numberNotifications = notifications.length;
    return (
        <AppBar position="static" color="secondary" id={"BottomBar"} elevation={0}>
            <Grid className={`${classes.groupedTextHorizontal}`}>
                <Link to={routes.menu} className={`${classes.link}`}>
                    <IconButton classes={{ root: classes.IconButtonRoot }}>
                        {lowerBarState === LowerbarState.MENU ? <SelectedPlayIcon /> : <PlayIcon />}
                    </IconButton>
                </Link>
                <Link to={routes.stats} className={`${classes.link}`}>
                    <IconButton classes={{ root: classes.IconButtonRoot }}>
                        {lowerBarState === LowerbarState.STATS ? <SelectedStatsIcon /> : <StatsIcon />}
                    </IconButton>
                </Link>
                <Link to={routes.notificationsPanel} className={`${classes.link}`}>
                    <IconButton classes={{ root: classes.IconButtonRoot }}>
                        <Badge color="secondary" badgeContent={numberNotifications} classes={{ badge: classes.badge }}>
                            {lowerBarState === LowerbarState.NOTIFICATIONS ? <SelectedProfileIcon /> : <ProfileIcon />}
                        </Badge>
                    </IconButton>
                </Link>
                <Link to={routes.profile}>
                    <IconButton classes={{ root: classes.IconButtonRoot }}>
                        {lowerBarState === LowerbarState.SETTINGS ? <SelectedSettingsIcon /> : <SettingsIcon />}
                    </IconButton>
                </Link>
            </Grid>
        </AppBar>
    );
}
